
export const GENERATE_AND_STORE_OTP_REQUEST = "GENERATE_AND_STORE_OTP_REQUEST";
export const GENERATE_AND_STORE_OTP_SUCCESS = "GENERATE_AND_STORE_OTP_SUCCESS";
export const GENERATE_AND_STORE_OTP_FAIL = "GENERATE_AND_STORE_OTP_FAIL";

export const SHOULD_PROCEED_TO_SIGNUP = "SHOULD_PROCEED_TO_SIGNUP";

export const VERIFY_OTP_REQUEST = "VERIFY_OTP_REQUEST";
export const VERIFY_OTP_SUCCESS = "VERIFY_OTP_SUCCESS";
export const VERIFY_OTP_FAIL = "VERIFY_OTP_FAIL";

export const LOGIN_REQUESTS = "LOGIN_REQUESTS";
export const LOGIN_REQUESTS_SUCCESS = "LOGIN_REQUESTS_SUCCESS";
export const LOGIN_REQUESTS_FAIL = "LOGIN_REQUESTS_FAIL";

// export const SIGNUP_OTP_SENT = "SIGNUP_OTP_SENT";
// export const SIGNUP_OTP_FAIL = "SIGNUP_OTP_FAIL";
// export const OTP_VERIFY_SUCCESS = "OTP_VERIFY_SUCCESS";
// export const OTP_VERIFY_FAIL = "OTP_VERIFY_FAIL";
// export const SAVE_TOKEN_IN_COOKIE = "SAVE_TOKEN_IN_COOKIE";
// export const SIGNUP_OTP_VERIFIED = "SIGNUP_OTP_VERIFIED";
// export const SIGNUP_OTP_VERIFICATION_FAIL = "SIGNUP_OTP_VERIFICATION_FAIL";
// export const SEND_PHONE_NUMBER_REQUEST = "SEND_PHONE_NUMBER_REQUEST";
// export const SEND_PHONE_NUMBER_SUCCESS = "SEND_PHONE_NUMBER_SUCCESS";
// export const SEND_PHONE_NUMBER_FAIL = "SEND_PHONE_NUMBER_FAIL";

export const SIGNUP_REQUEST = "SIGNUP_REQUEST";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAIL = "SIGNUP_FAIL";

// export const USER_INFO_REQUESTS = "USER_INFO_REQUESTS";
// export const USER_INFO_REQUESTS_SUCCESS = "USER_INFO_REQUESTS_SUCCESS";
// export const USER_INFO_REQUESTS_FAIL = "USER_INFO_REQUESTS_FAIL";

// export const USER_LOGOUT_REQUESTS = "USER_LOGOUT_REQUESTS";
// export const USER_LOGOUT_REQUESTS_SUCCESS = "USER_LOGOUT_REQUESTS_SUCCESS";
// export const USER_LOGOUT_REQUESTS_FAIL = "USER_LOGOUT_REQUESTS_FAIL";


// export const SEND_OTP_REQUEST = "SEND_OTP_REQUEST";
// export const SEND_OTP_SUCCESS = "SEND_OTP_SUCCESS";
// export const SEND_OTP_FAIL = "SEND_OTP_FAIL";

export const SIGNIN_REQUEST = "SIGNIN_REQUEST";
export const SIGNIN_SUCCESS = "SIGNIN_SUCCESS";
export const SIGNIN_FAIL = "SIGNIN_FAIL";

export const SIGNOUT_REQUEST = "SIGNOUT_REQUEST";
export const SIGNOUT_SUCCESS = "SIGNOUT_SUCCESS";
export const SIGNOUT_FAIL = "SIGNOUT_FAIL";

export const EMAIL_SIGNIN_REQUEST = "EMAIL_SIGNIN_REQUEST";
export const EMAIL_SIGNIN_SUCCESS = "EMAIL_SIGNIN_SUCCESS";
export const EMAIL_SIGNIN_FAIL = "EMAIL_SIGNIN_FAIL";

export const CHECK_AUTH_REQUEST = 'CHECK_AUTH_REQUEST';
export const CHECK_AUTH_SUCCESS = 'CHECK_AUTH_SUCCESS';
export const CHECK_AUTH_FAIL = 'CHECK_AUTH_FAIL';

export const GET_CURRENT_USER_REQUEST = 'GET_CURRENT_USER_REQUEST';
export const GET_CURRENT_USER_SUCCESS = 'GET_CURRENT_USER_SUCCESS';
export const GET_CURRENT_USER_FAIL = 'GET_CURRENT_USER_FAIL';

export const CHECK_USER_EXISTS_REQUEST = 'CHECK_USER_EXISTS_REQUEST';
export const CHECK_USER_EXISTS_SUCCESS = 'CHECK_USER_EXISTS_SUCCESS';
export const CHECK_USER_EXISTS_FAIL = 'CHECK_USER_EXISTS_FAIL';

export const CHECK_EMAIL_EXISTS_REQUEST = 'CHECK_EMAIL_EXISTS_REQUEST';
export const CHECK_EMAIL_EXISTS_SUCCESS = 'CHECK_EMAIL_EXISTS_SUCCESS';
export const CHECK_EMAIL_EXISTS_FAIL = 'CHECK_EMAIL_EXISTS_FAIL';

export const GENERATE_RECAPTCHA_VERIFIER = 'GENERATE_RECAPTCHA_VERIFIER';
export const CREATE_RECAPTCHA_WIDGET  = 'CREATE_RECAPTCHA_WIDGET ';

export const SET_AUTH_TOKENS  = 'SET_AUTH_TOKENS';

export const CHECK_LOGIN_STATUS = 'CHECK_LOGIN_STATUS';


